/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_SettingsInputs */

const en_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing Settings`)
};

const fr_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de minutage`)
};

const de_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeiteinstellungen`)
};

const it_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di temporizzazione`)
};

const ru_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки времени`)
};

const es_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes de tiempo`)
};

const zh_cn2_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计时设置`)
};

const ja_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミング設定`)
};

const hi_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय सेटिंग्स`)
};

const pt_pt2_timing_settings = /** @type {(inputs: Timing_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de tempo`)
};

/**
* | output |
* | --- |
* | "Timing Settings" |
*
* @param {Timing_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_settings = /** @type {((inputs?: Timing_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_settings(inputs)
	if (locale === "de") return de_timing_settings(inputs)
	if (locale === "it") return it_timing_settings(inputs)
	if (locale === "ru") return ru_timing_settings(inputs)
	if (locale === "es") return es_timing_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_settings(inputs)
	if (locale === "ja") return ja_timing_settings(inputs)
	if (locale === "hi") return hi_timing_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_settings(inputs)
	return en_timing_settings(inputs)
});